<template>
  <div class="container-fluid d-flex flex-column p-0" :class="rootClass">
    <div class="d-flex flex-column w-100" :class="layoutWrapperClass">
      <slot name="header">
        <component :is="headerComponent" v-bind="headerProps" />
      </slot>
      <div class="d-flex flex-column w-100 overflow-auto" :class="contentWrapperClass">
        <slot />
      </div>
    </div>
    <slot name="footer">
      <weseedo-footer v-if="showFooter" />
    </slot>
  </div>
</template>

<script>
export default {
  name: 'PageLayout',
  props: {
    /** When true, add meek-specific wrapper classes (e.g. meek-color-dark-gray, h-100) */
    meek: {
      type: Boolean,
      default: null
    },
    /** Passed to MeekijkenHeader when meek: useHeaderWithoutPayoff */
    useHeaderWithoutPayoff: {
      type: Boolean,
      default: false
    },
    /** When true, show the footer (default false) */
    showFooter: {
      type: Boolean,
      default: false
    },
    /** Extra class for the inner content wrapper (e.g. flex-grow-1, justify-content-center) */
    contentClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    isMeek () {
      return this.meek !== null ? this.meek : this.$store.getters.isMeekijken
    },
    isAndroidWebView () {
      return this.$store.getters.getIsAndroidWebView
    },
    headerComponent () {
      return this.isMeek ? 'meekijken-header' : 'weseedo-header'
    },
    headerProps () {
      if (this.isMeek) {
        return { useHeaderWithoutPayoff: this.useHeaderWithoutPayoff }
      }
      return {}
    },
    rootClass () {
      // WSD with footer: lock the outer container to the viewport so the footer stays pinned at the bottom
      if (!this.isMeek && this.showFooter) {
        return 'vh-100'
      }
      return ''
    },
    layoutWrapperClass () {
      if (this.isMeek) {
        const meekClasses = ['h-100', 'meek-color-dark-gray', 'justify-content-center']
        if (!this.showFooter) {
          meekClasses.push('meek-appointment')
        }
        return meekClasses.join(' ')
      }
      // WSD with footer: fill the space above the footer; min-h-0 lets the inner content scroll
      if (this.showFooter) {
        return 'flex-grow-1 min-h-0'
      }
      return 'h-100'
    },
    contentWrapperClass () {
      if (this.isMeek) {
        return ['justify-content-center', this.contentClass].filter(Boolean).join(' ')
      }
      // WSD with footer: content fills the wrapper and scrolls on its own (min-h-0 lets it shrink)
      if (this.showFooter) {
        return ['flex-grow-1', 'min-h-0', this.contentClass].filter(Boolean).join(' ')
      }
      return this.contentClass || ''
    }
  }
}
</script>

<style lang="scss" scoped>
// Let the flex item shrink below its intrinsic height so it scrolls instead of pushing the footer off-screen
.min-h-0 {
  min-height: 0;
}
</style>
